export default __webpack_public_path__ + "static/media/deni-teresa.30db3900.jpg";